const countFormat = (count: number | undefined) => {
  if (!count) return 0;
  return count.toLocaleString();
};

export default countFormat;
